export default "__VITE_ASSET__Coz6YnR2__"